import { create } from "zustand";

/**
 * Backoffice global UI state.
 *
 * L'auth è gestita dal `AuthContext` (per via dell'hydration localStorage + il
 * fatto che React Router consuma le info di login). Qui teniamo solo UI state
 * trasversale: sidebar collapsed, toast/notifiche.
 */

interface ToastState {
  kind: "success" | "error" | "info";
  message: string;
}

interface State {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;

  toast: ToastState | null;
  showToast: (t: ToastState) => void;
  clearToast: () => void;
}

export const useStore = create<State>((set) => ({
  sidebarCollapsed: false,
  toggleSidebar: () =>
    set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),

  toast: null,
  showToast: (toast) => {
    set({ toast });
    setTimeout(() => set({ toast: null }), 3200);
  },
  clearToast: () => set({ toast: null }),
}));
